var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"timing-hall"},[_c('router-view',{staticClass:"timing-hall__data"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }